import { useEffect, useState } from "react";
import SideMenu from "../../components/organisms/SideMenu";
import DetailCard from "../../components/molecules/DetailCard";
import api from "../../Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import SidePopUp from "../../components/organisms/testimonials/SidePopUp";
import { IoMdAdd } from "react-icons/io";

// Type for the structure of each testimonial
interface TestimonialData {
  _id: string; // Ensure _id is included in the type
  Img: string;
  Name: string;
  Position: string;
  Description: string;
}

export default function TestimonialPage() {
  const [testimonials, setTestimonials] = useState<TestimonialData[]>([]);
  const [loading, setLoading] = useState(true);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(api.testimonial, {
          headers: {
            api_key: api.key,
            authentication: api.authantication,
          },
        });
        setTestimonials(response.data.Testimonials);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Delete testimonial handler
  const handleDeleteTestimonial = async (testimonialId: string) => {
    try {
      await axios.delete(`${api.testimonial}/${testimonialId}`, {
        headers: {
          api_key: api.key,
          authentication: api.authantication,
        },
      });

      // Remove the deleted testimonial from the state
      setTestimonials((prevTestimonials) =>
        prevTestimonials.filter(
          (testimonial) => testimonial._id !== testimonialId
        )
      );
    } catch (error) {
      console.error("Error deleting testimonial:", error);
    }
  };

  const handlePopUpClose = () => {
    setIsPopUpOpen(false);
  };

  const handleTestimonialAdded = (newTestimonial: TestimonialData) => {
    setTestimonials((prevTestimonials) => [
      ...prevTestimonials,
      newTestimonial,
    ]);
  };

  return (
    <div className="flex">
      <SideMenu />
      <div className="p-6 bg-background w-full">
        <div className="flex items-center space-x-10">
          <div className="space-y-1">
            <h1 className="font-primary text-[32px]">Testimonial</h1>
            <p>Manage your testimonial</p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4 mt-4">
          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
                <Skeleton key={index} height={150} />
              ))
            : testimonials.map((testimonial) => (
                <DetailCard
                  key={testimonial._id} // Use _id as the key
                  Name={testimonial.Name}
                  Position={testimonial.Position}
                  Description={testimonial.Description}
                  ImageUrl={testimonial.Img}
                  HandleDelete={() => handleDeleteTestimonial(testimonial._id)} // Pass _id here
                />
              ))}
        </div>
      </div>
      <SidePopUp
        isPopUpOpen={isPopUpOpen}
        onClose={handlePopUpClose}
        onTestimonialAdded={handleTestimonialAdded}
        Title="Add Testimonial"
        SubTitle="Add testimonial details below"
        SubmitButtonText="Add a Testimonial"
      />

      <div
        onClick={() => setIsPopUpOpen(true)}
        className="bg-primary w-[46px] h-fit hover:w-[180px] p-3 text-[22px] text-white rounded-full fixed right-4 bottom-4 group duration-300 flex items-center gap-2 cursor-pointer"
      >
        <IoMdAdd />
        <p className="text-[16px] hidden h-[24px] pr-2 group-hover:flex duration-300">
          Add Testimonial
        </p>
      </div>
    </div>
  );
}
